import { VsInformationIcon } from '@octane/spark'
import styled from 'styled-components'

const GraphiteInformationIcon = styled(VsInformationIcon).attrs(
    ({ theme }) => ({
        color: theme.colors.monochrome.graphite,
    }),
)``

export default GraphiteInformationIcon
